// Holds the list of My Content type keys currently HIDDEN from the map.
// Empty array = everything visible (the default). See the eye toggle in
// src/component/main-ui/left-toolbar/my-content and the render-* consumers.

import {
  TOGGLE_CONTENT_TYPE_VISIBILITY,
  CONTENT_TYPES_VISIBILITY_RESET,
} from '../action/hidden-content-types-actions'

const initialState = []

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_CONTENT_TYPE_VISIBILITY: {
      const type = action.payload
      return state.includes(type)
        ? state.filter(t => t !== type)
        : [...state, type]
    }
    case CONTENT_TYPES_VISIBILITY_RESET:
    case 'LOGOUT':
      return initialState
    default:
      return state
  }
}
